<div class="container">
  <div class="title">
    {{documentTypeLabel}}
  </div>

  @for (doc of documents; track doc) {
    <div class="existing-document-row">
      <a class="customLink" (click)="onDownloadFileClicked(doc)">
        <div class="filename">{{doc.filename}}</div>
      </a>
      <button class="action-button" mat-button mat-stroked-button color="warn" (click)="onDeleteButtonClicked(doc)" [disabled]="doc.isDeleting">
        <mat-icon>delete</mat-icon>
        Delete
      </button>
    </div>
  }

  @for (doc of documentsPendingUpload; track doc) {
    <div class="existing-document-row">
      <a class="customLink" (click)="downloadPendingUpload(doc)">
        <div class="filename">{{doc.file.name}}</div>
      </a>
      @if (!doc.uploading) {
        <button class="action-button" mat-button mat-stroked-button color="warn"
          [disabled]="uploading"
          (click)="removePendingUpload(doc)">
          <mat-icon>delete</mat-icon>
          Delete
        </button>
      }
      @if (doc.uploading) {
        <div class="upload-spinner">
          <div class="upload-spinner__content">
            <div>Uploading</div>
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </div>
        </div>
      }
    </div>
  }

  <div class="document-upload-row">
    @if (documents.length == 0 && documentsPendingUpload.length == 0) {
      <div class="filename no-document-message">
        No documents on File
      </div>
    }
    @if (documents.length > 0 || documentsPendingUpload.length > 0) {
      <div class="filename">
        Add Additional Documents
      </div>
    }


    @if (!uploading || documentsPendingUpload.length > 0) {
      <button class="action-button" mat-button mat-raised-button color="primary"
        (click)="fileUpload.click()" [disabled]="loadingDocuments || uploading">
        <mat-icon>cloud_upload</mat-icon>
        Upload
      </button>
    }
    @if (uploading && documentsPendingUpload.length == 0) {
      <div class="upload-spinner">
        <div class="upload-spinner__content">
          <div>Uploading</div>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      </div>
    }

    <input class="file-input" type="file" accept=".pdf, .doc, .docx" (change)="onFileSelected($event)" #fileUpload>

  </div>
</div>
